<template>
  <naj-box :title="formModel.casePartyRole === casePartyRoleEnum.judicialGuard ? local.judicialGuardForms.title : local.liquidatorForm.title">
    <v-row>
      <v-col cols="3">
        <naj-input
          :type-id="formFieldType.number"
          :label="formModel.casePartyRole === casePartyRoleEnum.judicialGuard ? local.judicialGuardForms.judgementNumber : local.liquidatorForm.judgementNumber"
          :value.sync="formModel.judgementCode"
          :disabled="viewMode"
          :validates="`required|isValid:${local.liquidatorForm.invalidNumber},${isNumberValid}|isVerified:${true || formModel.isVerified}`"
          @input="/*changeVerification(false)*/"
        ></naj-input>
      </v-col>
      <v-col cols="4">
        <naj-input
          :type-id="formFieldType.date"
          :label="local.liquidatorForm.judgementDate"
          :value.sync="formModel.judgementDate"
          :disabled="viewMode"
          validates="required"
        ></naj-input>
      </v-col>
      <v-col cols="3">
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.liquidatorForm.judgementSource"
          :value.sync="formModel.judgementSourceId"
          :disabled="viewMode"
          :items="publicAndPersonalStatusCourts"
          item-text="name"
          item-value="id"
          validates="required"
        ></naj-input>
      </v-col>
      <v-col
        v-if="false && !formModel.isVerified"
        cols="12"
        lg="3"
        class="d-flex align-center"
      >
        <naj-button
          square
          inputs-alignment
          :loading="isChecking"
          :disabled="!isCheckingValidityValid"
          @click="validateJudgementNumber"
        >
          {{ local.common.check }}
        </naj-button>
      </v-col>
    </v-row>
  </naj-box>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { casePartyRoleEnum } from '@/helpers/enum';
const { mapState: mapLUTState, mapActions: mapLUTActions } = createNamespacedHelpers(
  'LookupsModule'
);
export default {
  inject: ['$validator'],
  props: ['formModel', 'liquidatorSocialId', 'viewMode'],
  data() {
    return {
      isChecking: false,
      casePartyRoleEnum,
    };
  },
  computed: {
    ...mapLUTState(['publicAndPersonalStatusCourts']),
    isCheckingValidityValid() {
      return this.formModel.judgementCode && this.liquidatorSocialId && this.formModel.socialId;
    },
    isNumberValid() {
      return this.formModel.judgementCode !== 0;
    },
  },
  created() {
    this.changeVerification(false);
    this.getPublicAndPersonalStatusCourts();
  },
  methods: {
    ...mapLUTActions(['getPublicAndPersonalStatusCourts']),
    validateJudgementNumber() {
    },
    changeVerification(isVerified) {
      this.$set(this.formModel, 'isVerified', isVerified);
    },
  },
};
</script>
